import React from 'react';
import { Link } from 'react-router-dom';

function ListLink({ newsDetailItems, slug, url, image, title, description }) {
    return newsDetailItems ? (
        <Link to={`/news/${slug}`}>
            <div className={'grid-image'}>
                <img src={image.fields.file.url} alt={image.fields.title} />
            </div>
            <div className={'grid-text'}>
                <h3>{title}</h3>
                <p>{description}</p>
            </div>
        </Link>
    ) : (
        <a href={url} target={'_blank'} rel="noopener noreferrer">
            <div className={'grid-image'}>
                <img src={image.fields.file.url} alt={image.fields.title} />
            </div>
            <div className={'grid-text'}>
                <h3>{title}</h3>
                <p>{description}</p>
            </div>
        </a>
    );
}

export default ListLink;
